// Update these values after creating your AWS resources

const config = {
  apiUrl: 'https://rutwb.people.aws.dev',
  uploadApiUrl: 'https://itfigkty8c.execute-api.us-east-1.amazonaws.com/prod',
  cognito: {
    userPoolId: 'us-east-1_EKxb4v1OF',
    clientId: '6o5sgq1jt8sh74vjao6mc2dmv0',
    domain: 'us-east-1ekxb4v1of.auth.us-east-1.amazoncognito.com',
    redirectUri: 'https://rutwb.people.aws.dev/',
    region: 'us-east-1'
  }
};

export default config;
